import PropTypes from "prop-types";

// Layouts
import TierItemsLayout from "@/Layouts/components/Tiers/TierItemsLayout";

// Constants
const MAX_COMMISSIONS = 99999;

export default function RenderColumns(props) {
	const {
		columns,
		content,
		errors = null,
		errorsMessages = [],
		readOnly = false,
		onAddTier = () => {},
		onDeleteTier = () => {},
		onHandleUpdateValue = () => {},
	} = props;

	return (
		<TierItemsLayout
			minimumRows={1}
			columnSpacing={4}
			rows={content[columns._id] || []}
			columns={[
				{
					_id: columns?.left?._id,
					title: columns?.left?.title || "",
					component: {
						type: "DoubleInput",
						order: columns?.left?.useValues || [],
						disableCommonInputs: true,
						properties: {
							firstInput: {
								data: [
									{
										type: "Unit",
										min: 0,
										max: MAX_COMMISSIONS,
										decimalsEditable: true,
										decimals: 1,
										delta: 0.5,
										disabled: true,
									},
								],
								sx: { maxWidth: "75px" },
							},
							secondInput: {
								data: [
									{
										type: "Unit",
										min: 0,
										max: MAX_COMMISSIONS,
										decimalsEditable: true,
										decimals: 1,
										delta: 0.5,
									},
								],
								sx: { maxWidth: "75px" },
							},
						},
						callbacks: {
							onActionUpdate: (positions, area, value) =>
								onHandleUpdateValue({
									column: columns?._id,
									row: positions.row,
									area,
									value,
								}),
						},
					},
				},
				{
					_id: columns?.right?._id,
					title: columns?.right?.title || "",
					component: {
						type: "InputForm",
						order: columns?.right?.useValues,
						properties: {
							input: {
								data: [
									{
										type: "Dollar",
										min: 0,
										max: MAX_COMMISSIONS,
										decimalsEditable: false,
										decimals: 2,
									},
								],
								sx: { maxWidth: "95px" },
							},
						},
						callbacks: {
							onActionUpdate: (positions, area, value) =>
								onHandleUpdateValue({
									column: columns?._id,
									row: positions.row,
									area,
									value,
								}),
						},
					},
				},
			]}
			errors={errors}
			errorsMessages={errorsMessages}
			readOnly={readOnly}
			onActionAdd={() => onAddTier(columns?._id, columns?.right?.useValues)}
			onActionDelete={() => onDeleteTier(columns?._id)}
		/>
	);
}
RenderColumns.propTypes = {
	content: PropTypes.object,
	columns: PropTypes.shape({
		_id: PropTypes.string,
		left: PropTypes.object,
		right: PropTypes.object,
	}),
	errors: PropTypes.object,
	errorsMessages: PropTypes.array,
	readOnly: PropTypes.bool,
	onAddTier: PropTypes.func,
	onDeleteTier: PropTypes.func,
	onHandleUpdateValue: PropTypes.func,
};
